// extracted by mini-css-extract-plugin
module.exports = {"MainContent":"MainContent_MainContent__323WI","ExperienceContainer":"MainContent_ExperienceContainer__2DGHY"};